module.exports = __webpack_public_path__ + "img/chivas-21-nam-royal-salute-_2.ffe53e91.jpg";